import router from "../router";
import storeConfig from "@/store";
import registerModule from "./registerModule";

const moduleImports = import.meta.glob<{ default: unknown }>(
  "@/modules/*/index.ts",
  { eager: true }
);

const getModuleByName = (moduleName: string) => {
  const matchedEntry = Object.entries(moduleImports).find(([key]) =>
    key.includes(`/modules/${moduleName}/index.ts`)
  );

  const moduleEntry = matchedEntry?.[1];
  if (!moduleEntry) return null;

  // Webpack require() returned the module namespace; Vite eager glob does the same.
  // Module index files use named exports (`export { store, router }`), not default.
  return (moduleEntry as { default?: unknown }).default ?? moduleEntry;
};

const registerModules = () => {
  const allowModules = (import.meta.env.VUE_APP_ACTIVE_MODULES || "")
    .split(",")
    .filter(Boolean);

  const modules = allowModules.reduce(
    (acc: Record<string, unknown>, module: string) => {
      const currentModule = getModuleByName(module);
      if (currentModule) {
        acc[module] = currentModule;
      }
      return acc;
    },
    {}
  );

  Object.entries(modules).forEach(([moduleKey, module]) => {
    registerModule({ moduleKey, module, router, storeConfig });
  });

  return { storeConfig, router };
};

export default registerModules;
